module.exports = __webpack_public_path__ + "static/media/calender.6f14e5b7.svg";